/**@jsx jsx */
import { css, jsx } from '@emotion/core'
import { Button } from '@material-ui/core'
import PhoneIcon from '@material-ui/icons/Phone';
import EmailIcon from '@material-ui/icons/Email';

const ContactInfo = (props) => {
    const {cssContactInfo} = props;

    // check if working (phone this number on mobile)
    const handleCellphone = () => {
        window.open('tel:+972542450222');
    }

    // check if working (phone this number on mobile)
    const handleTelephone = () => {
        window.open('tel:+97239525075');
    }

    const handleMail = () => {
        window.location.href = "mailto:ronencarmely@gmail.com; motion@motion.co.il"
    }

    const contactContainer = css`
    display: flex;
    justify-content: space-evenly;
    `;

    const gridItem = css`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    .MuiButton-outlined {
        border: 2px solid #69d74d;
    }
    .MuiButton-root {
        font-family: inherit;
        width: 125%;
        background-color: #69d74d;
        color: white;
        font-weight: bold;
        font-size: inherit;
    :hover {
        transition: 0.2s;
        color: black;
        font-size: larger;
        }
    }
    `;

    const gridMailItem = css`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    .MuiButton-outlined {
        border: 2px solid #55baff;
    }
    .MuiButton-root {
        font-family: inherit;
        width: 125%;
        background-color: #55baff;
        color: white;
        font-weight: bold;
        font-size: inherit;
    :hover {
        transition: 0.2s;
        color: black;
        font-size: larger;
        }
    }
    `;

    const buttonStyle = css`
    .MuiButton-label {
        flex-direction: row-reverse;
    }
    .MuiButton-label {
        font-family: Segoe UI;
        font-size: 83%;
    }
    `;

    const textStyle = css`
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 500;
    font-size: medium;
    `;

    return (
        <div css={contactContainer}>
            <div css={cssContactInfo}>
                <div css={gridItem}>
                    <Button
                        css={buttonStyle}
                        onClick={handleCellphone}
                        variant="outlined"
                        startIcon={<PhoneIcon />}
                    >
                        054-2450222
                </Button>
                </div>
                <div css={gridItem}>
                    <Button
                        css={buttonStyle}
                        onClick={handleTelephone}
                        variant="outlined"
                        startIcon={<PhoneIcon />}
                    >
                        03-9525075
                </Button>
                </div>
                <div css={gridMailItem}>
                    <Button
                        css={buttonStyle}
                        onClick={handleMail}
                        variant="outlined"
                        startIcon={<EmailIcon />}
                    >
                        שלח מייל
                    </Button>
                </div>
                <div css={textStyle}>motion@motion.co.il</div>
            </div>
        </div>
    );
}

export default ContactInfo;